var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoropheneCoating(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.5018 41.7912V46.8277C61.5018 46.8512 61.7996 47.1491 61.8231 47.1491H69.2128C69.3199 47.1491 69.0501 45.2632 69.3178 45.0081L90.8465 54.2194C90.5745 54.2173 90.3046 54.273 90.0583 54.3909C77.6928 60.2803 64.9268 65.4432 52.3943 70.9468L43.1367 67.0248C41.9865 64.5216 40.5386 62.1599 39.0992 59.8131C38.0453 58.0921 36.3125 54.9117 35.1216 53.5058C31.9472 49.7617 28.912 58.21 27.3227 60.021L13.7363 54.2194L35.0744 45.2439C35.6828 45.1067 35.2415 46.7677 35.37 47.1491H42.7598C42.7833 47.1491 43.0811 46.8512 43.0811 46.8277V42.1127L48.4359 39.8624V57.4363H56.1469V39.6481L61.5018 41.7912Z",
    fill: "#00516B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4378 54.8645C36.5586 61.534 45.8011 70.6189 41.2409 78.4222C37.816 84.2816 29.3617 84.5816 25.5554 78.9365C20.3141 71.1611 29.4923 61.6498 32.9944 54.9995L33.4378 54.8645ZM27.4746 72.8992C27.3675 72.9657 27.2369 73.6386 27.224 73.8358C27.0377 76.7119 29.8693 79.5816 32.701 79.7316C34.4145 79.8238 34.6052 78.1843 33.2857 77.8456C32.204 77.5692 31.615 77.7921 30.5505 76.9391C28.8519 75.5782 29.4238 73.8829 28.8476 73.0728C28.6655 72.8156 27.7017 72.7578 27.4768 72.8992H27.4746Z",
    fill: "#00516B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5357 23.6259C31.1906 21.4998 33.1334 41.4463 20.6736 42.8415C8.2139 44.2367 6.01198 25.4197 17.5357 23.6259ZM18.9836 34.0759C19.7162 34.2967 23.2461 34.0759 24.3385 34.0759C24.482 34.0759 24.8504 33.4094 24.8269 33.1458C24.7176 31.8985 22.6399 32.1235 21.7553 32.1364C21.4019 32.1406 20.3738 32.4493 20.3738 32.0421V27.3271C20.3738 26.5877 18.7887 26.0112 18.4931 27.3743C18.2961 28.283 18.3239 31.8963 18.4417 32.9036C18.4803 33.2315 18.6666 33.9838 18.9815 34.0781L18.9836 34.0759Z",
    fill: "#00516B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8691 27.0034L39.329 18L44.3647 27.0034H40.7234V38.255C40.7234 38.7951 38.1873 38.5122 37.7247 38.5765V27.0034H33.8691Z",
    fill: "#00516B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7104 27.0034H66.8549V38.255C66.8549 38.7372 63.8562 38.7372 63.8562 38.255V27.0034H60.2148L65.2506 18L70.7104 27.0034Z",
    fill: "#00516B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1504 37.2907L52.1861 28.2872L57.4318 37.2907H53.7904V48.8637H50.7917V37.2907H47.1504Z",
    fill: "#00516B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7233 40.934H37.7246V44.7917H40.7233V40.934Z",
    fill: "#00516B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8562 40.934H63.8574V44.7917H66.8562V40.934Z",
    fill: "#00516B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7897 51.2212H50.791V55.0789H53.7897V51.2212Z",
    fill: "#00516B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoropheneCoating);
export default __webpack_public_path__ + "static/media/Borophene Coating .9c93c324beb8333a37be5421fa11ccd1.svg";
export { ForwardRef as ReactComponent };